import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-video': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9A48-48 0 0 1 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM276.7 252.7L224 305.4V268C224 257 215 248 204 248H100C89 248 80 257 80 268V372C80 383 89 392 100 392H204C215 392 224 383 224 372V334.6L276.7 387.3C286.7 397.3 304 390.3 304 376V264C304 249.7 286.7 242.7 276.7 252.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-video.js
// module id = H91N
// module chunks = 144